// extracted by mini-css-extract-plugin
module.exports = {"institution":"Institution_institution__1fHAK","information":"Institution_information__2_a6m","actions":"Institution_actions__o2v3Z","form":"Institution_form__22ZL-"};